export default __webpack_public_path__ + "static/media/community.03991f6f.jpg";